export default __webpack_public_path__ + "static/media/13.6800f6ac.jpg";